import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { PaymentResult } from "../models/payment-result.model";

export class AsaasController {
    constructor(public _http: HttpClient) {
    }

    pay(key: string, paymentId: number): Promise<PaymentResult> {
        return this._http.get(API_ADDRESS + `/asaas/pay/${key}/${paymentId}`, httpOptionsDefault)
            .pipe(
                map(result => {
                    return result;
                }),
                catchError(error => {
                    return error;
                })
            )
            .toPromise().then((result: PaymentResult) => {
                return result;
            });
    }

    verify(tefId: number): Promise<PaymentResult> {
        return this._http.get(API_ADDRESS + `/asaas/verify/${tefId}`, httpOptionsDefault)
            .pipe(
                map(result => {
                    return result;
                }),
                catchError(error => {
                    return error;
                })
            )
            .toPromise().then((result: PaymentResult) => {
                return result;
            });
    }
}
